import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useWishlist } from "@/context/WishlistContext";
import { track } from "@/lib/meta";

export function WishlistButton({ tripId, className = "" }) {
  const { has, toggle } = useWishlist();
  const saved = has(tripId);
  return (
    <button type="button" aria-label={saved ? "Remove from wishlist" : "Save to wishlist"} data-testid="wishlist-btn" data-saved={saved}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(tripId); if (!saved) track("AddToWishlist", { content_ids: [tripId], content_type: "product" }); toast.success(saved ? "Removed from wishlist" : "Saved to your wishlist"); }}
      className={`h-9 w-9 rounded-full bg-white/90 backdrop-blur flex items-center justify-center shadow transition-transform duration-200 hover:scale-110 active:scale-95 ${className}`}>
      <Heart className={`h-4.5 w-4.5 h-[18px] w-[18px] transition-colors ${saved ? "fill-red-500 text-red-500" : "text-slate-700"}`} />
    </button>
  );
}
